// As linhas da lista de atendimentos que está à vista, na ordem da tela. As
// outras abas continuam montadas com display:none (são elas que contam cada
// aba); um querySelectorAll cru as traria junto, e j/k ou "Selecionar todos"
// agiriam em atendimentos que a pessoa não está vendo.
export const linhasDaListaVisivel = () =>
  [...document.querySelectorAll("[data-ticket-id]")].filter(
    (linha) => linha.getClientRects().length > 0,
  );
